import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "./components/Loader";
import ProtectedRoute from "./components/ProtectedRoute";
import { GlobalToast } from "./components/Toast";

const Login                = lazy(() => import("./public/Login"));
const ForgotPassword       = lazy(() => import("./public/Forgot_Password"));
const ResetOtpVerification = lazy(() => import("./public/ResetOtpVerification"));
const ResetPassword        = lazy(() => import("./public/ResetPassword"));
const Error                = lazy(() => import("./public/No_Page_Found"));
const InvitedToJoin        = lazy(() => import("./public/InvitedToJoin"));
const TwoFactorVerification= lazy(() => import("./public/Otp"));
const RoleLayout           = lazy(() => import("./Secure/RoleLayout"));

const App = () => (
  <Suspense fallback={<Loader />}>
    {/* Single global toast — no more per-page toast state */}
    <GlobalToast />

    <Routes>
      <Route path="/"                 element={<Login />} />
      <Route path="/forgot-password"  element={<ForgotPassword />} />
      <Route path="/verify-reset-otp" element={<ResetOtpVerification />} />
      <Route path="/reset-password"   element={<ResetPassword />} />
      <Route path="/accept-invite"    element={<InvitedToJoin />} />
      <Route path="/verify-2fa"       element={<TwoFactorVerification />} />

      <Route
        path="/super-admin/*"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <RoleLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <RoleLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/accountant/*"
        element={
          <ProtectedRoute allowedRoles={["finance"]}>
            <RoleLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer-care/*"
        element={
          <ProtectedRoute allowedRoles={["customer_service"]}>
            <RoleLayout />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Error />} />
    </Routes>
  </Suspense>
);

export default App;
